import { useTranslation } from 'next-i18next';

import FullscreenModal, {
  FullscreenModalProps,
} from '../common/FullscreenModal';
import RestrictionInfo from '../common/RestrictionInfo';
import Pad from '../layout/Pad';
import Push, { PushSize } from '../layout/Push';

const RestrictionInfoFullscreenModal = (props: FullscreenModalProps) => {
  const { t } = useTranslation();

  return (
    <FullscreenModal
      name="my-story-category-request"
      {...props}
      title={t('정책 위반')}
    >
      <Pad>
        <RestrictionInfo />
      </Pad>
      <Push size={PushSize.safe} bottom />
    </FullscreenModal>
  );
};

export default RestrictionInfoFullscreenModal;
